import { Css_BodyText_tw, HeadingH2 } from '@dreamstack/feature-components/src/layout/Texts'
import { useTranslation } from '@dreamstack/i18n'
import { SimpleTextLink } from '@dreamstack/simple-components/src/lib/SimpleTextLinks'
import type { FunctionComponent } from 'react'
import { useSearchContext } from '../SearchContext'
import { useSearchHits } from '../SearchHitsContext'

export const NewsSearchResultBox: FunctionComponent<
  React.PropsWithChildren<{}>
> = () => {
  const context = useSearchContext()
  const hits = useSearchHits()
  const t = useTranslation()
  if (!context) return null
  const { searchState, resetState } = context
  const query = searchState?.query
  const noOfResults = hits?.length || 0
  return (
    <>
      <div className="flex-1">
        <HeadingH2>
          {t('accentro:newsSearch.yourSearchFor')} &quot;{query}
          &quot;
        </HeadingH2>
        <div className={Css_BodyText_tw}>
          <span className="text-accentroGray-full">
            {noOfResults} {t('accentro:newsSearch.noOfResultsSuffix')} ·{' '}
          </span>
          <SimpleTextLink
            onClick={() => resetState()}
            className="font-semibold"
          >
            {t('accentro:newsSearch.resetAction')}
          </SimpleTextLink>
        </div>
      </div>
    </>
  )
}
